import { setCookie } from "../../../Services/CookieHandler";

window.addEventListener('DOMContentLoaded', () => {
    const annualMagazineModal = document.getElementById("annualMagazineModal");
    const openMagazineBtns = document.querySelectorAll(".openMagazineBtn");
    const annualMagazineCloseModal = document.querySelectorAll(".annualMagazineModal__iframeContainer--close");

    if (annualMagazineModal) {
        if (openMagazineBtns && openMagazineBtns.length > 0) {
            openMagazineBtns.forEach(element => {
                element.addEventListener("click", () => {
                    const magazineLink = element.getAttribute("data-magazine");
                    const iframeContainer = annualMagazineModal.querySelector(".annualMagazineModal__iframeContainer");
                    const existingIframe = document.getElementById("anuualMagazineIframe");

                    // Remove only the existing iframe, keeping the close button intact
                    if (existingIframe) {
                        iframeContainer.removeChild(existingIframe);
                    }

                    if (iframeContainer && magazineLink) {
                        const iframe = document.createElement("object");
                        iframe.id = "anuualMagazineIframe";
                        iframe.className = "annualMagazineModal__iframeContainer--iframe";
                        iframe.setAttribute("data", magazineLink);
                        iframe.innerHTML = `<a href="${magazineLink}">Download PDF</a>`;

                        // Append the new iframe to the container
                        iframeContainer.appendChild(iframe);

                        annualMagazineModal.style.display = "block"; 
                        setCookie("HasOpenedAnnualMagazine", true);
                        showFixedOpenMagazineButton(false);
                    }
                });
            });
        }

        if (annualMagazineCloseModal && annualMagazineCloseModal.length > 0) {
            annualMagazineCloseModal.forEach(closeElement => {
                closeElement.addEventListener("click", () => {
                    annualMagazineModal.style.display = "none"; 
                    showFixedOpenMagazineButton(true); 
                });
            });
        }

        // Handle closing the modal when clicking outside the iframe content
        window.onclick = (event) => {
            const iframeContainer = document.getElementsByClassName("annualMagazineModal__content")[0];
            if (iframeContainer && event.target === iframeContainer) {
                annualMagazineModal.style.display = "none";
                showFixedOpenMagazineButton(true); 
            }
        };
    }
});

function showFixedOpenMagazineButton(show) {
    const fixedOpenMagazineBtn = document.getElementById("fixedMagazineBtn");
    if (fixedOpenMagazineBtn) {
        fixedOpenMagazineBtn.style.opacity = show ? "1" : "0"; 
    }
}
